<ohp-title-announcer [announcement]="tabAnnouncement"></ohp-title-announcer>
<div id="tab-list-{{model.id}}"
     *ngIf="model.tabs[selectedTab]"
     class="tab-list"
     [ngClass]="{'tab-list--show-more-visible': model.tabs[selectedTab].loaded && !model.tabs[selectedTab].hasError && model.tabs[selectedTab].listModel?.showMoreVisible(showingTiles())}">
    <div [ngClass]="{'tab-list__height-restrictor': restrictHeight, 'height-restrictor--one-item': numItems === 1, 'height-restrictor--two-items': numItems === 2}">
        <div *ngIf="!hideHeader"
             class="list-header"
             [ngClass]="{'tab-list-header--flex': columnsEnabled || flexHeader,
                         'tab-list-header--tiles': showingTiles(),
                         'tab-list-header--buttons': tileViewEnabled,
                         'ms-u-hiddenLgDown': leftAlignedZeroExperience && model.tabs[selectedTab].showZeroExperience && model.tabs.length === 1 && model.tabs[selectedTab].loaded && !model.tabs[selectedTab].hasError && !(model.tabs[selectedTab].listModel?.items?.length),
                         'tiles-list-menu-header': tilesListMenuEnabled && tileViewEnabled,
                         'list-header--small': smallTitles}">
            <div class="responsive-width--outer" [ngClass]="{'tab-wrapper': columnsEnabled || flexHeader}">
                <div *ngIf="model.tabs.length"
                    class="tab-display responsive-width--inner {{model.tabClass}}"
                    [ngClass]="{'show-scroll': !isTouch}"
                    role="tablist">
                    <h3 class="list-header__title"
                        [ngClass]="{'tab-display__item': !pillTabs}"
                        *ngFor="let tab of model.tabs; let i=index; trackBy: trackByIndex">
                        <div *ngIf="model.tabs.length > 1" [ngClass]="{'tab-display__item--selected ms-bcl-tp': i === selectedTab && !pillTabs}">
                            <a id="tab-list-header-link-{{tab.id}}"
                               (click)="selectTab($event, i)"
                               [ngClass]="{
                                   'tab-display__item__link--pill': pillTabs,
                                   'tab-display__item__link ms-fcl-ns': !pillTabs,
                                   'tab-display__item__link--selected': i === selectedTab,
                                   'ms-fcl-nd': !pillTabs && i === selectedTab}"
                               data-clicklog="custom"
                               [attr.aria-label]="model.headerText ? (model.headerText + ', ' + tab.ariaLabel) : tab.ariaLabel"
                               role="tab"
                               [attr.aria-selected]="i === selectedTab"
                               [attr.data-text]="tab.title"
                               [title]="tab.title"
                               href="#">
                               {{ tab.title }}
                            </a>
                        </div>
                        <div *ngIf="model.tabs.length === 1" class="list-header__title ms-fcl-nd">
                            {{ tab.title }}
                        </div>
                    </h3>
                </div>
            </div>
            <div *ngIf="showTileToggle() || showTimestampHeader() || customButtonEnabled || showFilter"
                 class="tab-list-header__right"
                 [ngClass]="{'tab-list-header__right--float': !columnsEnabled && !flexHeader}">
                <div *ngIf="customButtonEnabled"
                     class="tab-list-header__custom-button">
                    <ng-content select="[ohpTabListButton]"></ng-content>
                </div>
                <ohp-text-filter *ngIf="showFilter" (filterInput)="filterInput($event)"></ohp-text-filter>
                <ohp-title-announcer *ngIf="showTileToggle()" [announcement]="toggleAnnouncement"></ohp-title-announcer>
                <button *ngIf="showTileToggle() && !tilesListMenuEnabled"
                   [id]="'tile-toggle-' + model.tabs[selectedTab].id"
                   class="icon-button tab-list-header__spacer ms-fcl-ns ms-bgc-g40-h ms-fcl-nd-f ms-fcl-nd-h ms-fcl-nd-a"
                   (click)="toggleTileView()"
                   [attr.data-area]="model.area"
                   [attr.aria-label]="showingTiles() ? showAsListAriaLabel : showAsTilesAriaLabel"
                   [title]="showingTiles() ? listViewText : tileViewText">
                    <ohp-icon-font [iconFontName]="showingTiles() ? 'ListBullets' : 'TileView'"
                                   cssClass="tile-toggle__icon tile-toggle__icon--centered"
                                   size="16"
                                   [ariaVisible]="true">
                    </ohp-icon-font>
                </button>
                <ohp-dropdown-menu *ngIf="showTileToggle() && tilesListMenuEnabled"
                                   [menuModel]="tilesListMenuModel"
                                   (toggleMenu)="onToggleTilesListMenu($event)"
                                   (selectItem)="onSelectTilesListMenuItem($event)">
                    <div ohpMenuLinkContent>
                        <ohp-icon-font [iconFontName]="showingTiles() ? 'TileView' : 'ListBullets'"
                                       cssClass="tile-toggle__icon"
                                       [ariaVisible]="true"
                                       size="16">
                        </ohp-icon-font>
                        <ohp-icon-font iconFontName="ChevronDown"
                                       size="8"
                                       cssClass="tiles-list-toggle__down-icon ms-fcl-bl">
                        </ohp-icon-font>
                    </div>
                    <div *ohpDropdownMenuItemContent="let item = item; let index = index" class="tiles-list-menu-item ms-fcl-np">
                        <ohp-icon-font *ngIf="item.view === itemView || item.view === tileView && itemView === cardView && model.tabs[selectedTab].showCardsInTileView"
                                        iconFontName="CheckMark"
                                        size="16"
                                        cssClass="tiles-list-checkmark__icon ms-fcl-tp"
                                        class="tiles-list-checkmark__icon-wrapper">
                        </ohp-icon-font>
                        <ohp-icon-font [iconFontType]="item.icon"
                                       [ngClass]="{'tiles-list-menu-item__spacer': !(item.view === itemView || item.view === tileView && itemView === cardView && model.tabs[selectedTab].showCardsInTileView)}"
                                       cssClass="tiles-list-menu-item__icon"
                                       size="16">
                        </ohp-icon-font>
                        <div class="tiles-list-menu-item__text">{{ item.title }}</div>
                    </div>
                </ohp-dropdown-menu>
                <div *ngIf="showTimestampHeader()"
                     class="tab-list-header__timestamp tab-list-header__spacer">
                    {{ model.tabs[selectedTab].timestampHeader }}
                </div>
            </div>
        </div>
        <div *ngIf="!model.tabs[selectedTab].loaded" class="tab-spinner-container">
            <div>
                <div class="ms-Spinner-circle ms-Spinner--medium"></div>
            </div>
        </div>
        <ohp-expandable-list *ngIf="itemViewExists()" [listId]="model.tabs[selectedTab].id" [area]="model.area" [listModel]="model.tabs[selectedTab].listModel" [itemView]="itemView" [(listState)]="listState" [selectedTab]="selectedTab">
            <div *ohpListItem="let item = item; let index = index; let itemView = itemView; let focusOnLoad = focusOnLoad;">
                <ng-template [ngTemplateOutlet]="listItemTemplate" [ngTemplateOutletContext]="{item: item, index: index, itemView: itemView, listId: model.tabs[selectedTab].id, focusOnLoad: focusOnLoad}"></ng-template>
            </div>
        </ohp-expandable-list>
        <ng-container *ngIf="model.tabs[selectedTab].loaded && (model.tabs[selectedTab].hasError || (model.tabs[selectedTab].showZeroExperience && !(model.tabs[selectedTab].listModel?.items?.length)))">
            <hr *ngIf="!isVisualRefresh" class="ms-bclt-g40" />
            <div *ngIf = "model.tabs[selectedTab]?.showZeroExperience || model.tabs[selectedTab].hasError" [ngClass]="{'default-state--middle': !leftAlignedZeroExperience,
                         'default-state--left': leftAlignedZeroExperience,
                         'default-state--middle--padded': !leftAlignedZeroExperience,
                         'default-state--middle--min-height': !defaultStateNoMinHeight && !leftAlignedZeroExperience }">
                <div *ngIf="model.tabs[selectedTab].hasError ? model.tabs[selectedTab].errorImage : model.tabs[selectedTab].zeroExperienceImage"
                     [ngClass]="[model.tabs[selectedTab].hasError ? model.tabs[selectedTab].errorImage : model.tabs[selectedTab].zeroExperienceImage, leftAlignedZeroExperience ? 'default-state__image--left' : '']" aria-hidden="true"></div>
                <div class="default-state__text"
                     *ngIf="model.tabs[selectedTab].hasError ? model.tabs[selectedTab].errorTitle : model.tabs[selectedTab].zeroExperienceTitle"
                     [ngClass]="{'default-state__text--middle': !leftAlignedZeroExperience,
                             'default-state__text--left': leftAlignedZeroExperience}">
                    <div class="default-state__title ms-fcl-ns"
                         [ngClass]="{'default-state__title--left': leftAlignedZeroExperience}">{{ model.tabs[selectedTab].hasError ? model.tabs[selectedTab].errorTitle : model.tabs[selectedTab].zeroExperienceTitle }}</div>
                    <div *ngIf="model.tabs[selectedTab].hasError ? model.tabs[selectedTab].errorSubtitle : model.tabs[selectedTab].zeroExperienceSubtitle"
                         class="default-state__subtitle ms-fcl-nd">{{ model.tabs[selectedTab].hasError ? model.tabs[selectedTab].errorSubtitle : model.tabs[selectedTab].zeroExperienceSubtitle }}</div>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="model.tabs[selectedTab].loaded && !model.tabs[selectedTab].hasError && model.tabs[selectedTab].listModel?.items?.length && model.tabs[selectedTab].footerText"
         class="tab-list-footer__middle ms-fcl-np">
         {{ model.tabs[selectedTab].footerText }}
    </div>
    <div *ngIf="(model.tabs[selectedTab].attribution?.url || model.tabs[selectedTab].attribution?.onClick)  && model.tabs[selectedTab].loaded"
         class="widget-attribution"
         [ngClass]="{'widget-attribution--left': model.tabs[selectedTab].attribution.leftAligned,
                     'widget-attribution--right': !model.tabs[selectedTab].attribution.leftAligned,
                     'widget-attribution--middle': leftAlignedZeroExperience && model.tabs[selectedTab].loaded && (model.tabs[selectedTab].hasError || (model.tabs[selectedTab]?.showZeroExperience && !(model.tabs[selectedTab].listModel?.items?.length)))}">
        <a id="attribution-{{model.tabs[selectedTab].id}}"
           [attr.href]="model.tabs[selectedTab].attribution.url || '#'"
           [attr.data-referral]="model.tabs[selectedTab].attribution.referral"
           [attr.data-area]="model.area"
           (click)="widgetAttributionClick($event)"
           class="widget-attribution__link ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a"
           [ngClass]="{'widget-attribution__link--fluent': fluentRefresh}"
           rel="noopener"
           ohpDefaultLinkTarget
           [attr.aria-label]="model.tabs[selectedTab].attribution.ariaLabel"
           [attr.title]="model.tabs[selectedTab].attribution.tooltip">
            <span>{{ (model.tabs[selectedTab].attribution.zeroTitle && (model.tabs[selectedTab].hasError || (model.tabs[selectedTab].showZeroExperience  && !(model.tabs[selectedTab].listModel?.items?.length)))) ? model.tabs[selectedTab].attribution.zeroTitle : model.tabs[selectedTab].attribution.title }}</span>
            <ohp-icon-font iconFontName="ArrowRight" size="14" cssClass="link-arrow"></ohp-icon-font>
        </a>
    </div>
</div>
